export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-award-line',
      title: 'High-Quality Craftsmanship',
      description: 'Every project is completed with meticulous attention to detail and superior workmanship.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Honest Pricing',
      description: 'Transparent quotes with no hidden fees. You know exactly what you\'re paying for.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Professional Communication',
      description: 'We keep you informed every step of the way with clear, timely updates.'
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'Custom Luxury Finishes',
      description: 'Premium materials and custom designs tailored to your vision and lifestyle.'
    },
    {
      icon: 'ri-map-pin-user-line',
      title: 'Local Michigan Contractor',
      description: 'Proudly serving Southeast Michigan communities with dedicated local service.'
    }
  ];

  return (
    <section id="why-choose-us" className="py-24 bg-gradient-to-br from-slate-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-teal-600 text-sm font-bold tracking-wider uppercase">Trust & Quality</span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mt-3 mb-4">
            Why Homeowners Choose Us
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            We're committed to delivering exceptional results that exceed your expectations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-100 hover:border-teal-200"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-teal-600 rounded-xl mb-6">
                <i className={`${reason.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{reason.title}</h3>
              <p className="text-slate-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex flex-wrap justify-center items-center gap-6 bg-white rounded-2xl px-8 py-8 shadow-lg w-full max-w-2xl mx-auto">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-shield-check-line text-teal-600 text-4xl"></i>
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-slate-900 whitespace-nowrap">Insured</div>
                <div className="text-sm text-slate-600 whitespace-nowrap">Fully Protected</div>
              </div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-slate-200"></div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-time-line text-teal-600 text-4xl"></i>
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-slate-900 whitespace-nowrap">10+ Years</div>
                <div className="text-sm text-slate-600 whitespace-nowrap">Experience</div>
              </div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-slate-200"></div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-star-line text-teal-600 text-4xl"></i>
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-slate-900 whitespace-nowrap">100%</div>
                <div className="text-sm text-slate-600 whitespace-nowrap">Satisfaction</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}